export interface MoveDetailBackTargetArgs {
    path?: string | null;
    protocolId?: number | string | null;
}

export const ProtocolSection = {
    inventory: 'inventoryTab',
    laboratoryKit: 'laboratoryKitTab'
};

const PROTOCOL_SECTION_BY_AREA = [
    { area: '/laboratorykit/', section: ProtocolSection.laboratoryKit },
    { area: '/inventory/', section: ProtocolSection.inventory }
];

export function protocolSectionTarget(protocolId: number | string | null | undefined, section: string): string | null {
    if (protocolId == null || protocolId === '') return null;
    return `/admin/protocols/${protocolId}/section/${section}`;
}

export function resolveMoveDetailBackTarget({ path, protocolId }: MoveDetailBackTargetArgs): string | null {
    const route = (path ?? '').toLowerCase();
    const match = PROTOCOL_SECTION_BY_AREA.find(candidate => route.includes(candidate.area));
    if (match == null) return null;

    return protocolSectionTarget(protocolId, match.section);
}
